import './main.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import ChangeEmailApp from './apps/change-email.vue';
import CommercialErrorreportApp from './apps/commercial-errorreport.vue';
import OncallErrorreportApp from './apps/oncall-errorreport.vue';

import SearchApp from './apps/search.vue';
import MyPagesApp from './apps/my-pages.vue';
import Navigation from './components/navigation/navigation.vue';
import OfflineNotice from './components/offline-notice.vue';
import { RENDERING_MODES } from './config/constants.js';
import { createApp } from 'vue';
import dayjs from 'dayjs';
import dayjsPlugin from './plugins/dayjs.js';
import { renderMode } from './helpers/index.js';
import router from './router/index.js';
import store from './store/index.js';
import veeValidatePlugin from './plugins/veevalidate.js';

document.addEventListener("DOMContentLoaded", () => {

// Create app instance
const app = createApp(OfflineNotice); // Default app can be set as OfflineNotice

// Global components
app.component('Navigation', Navigation);
app.component('OfflineNotice', OfflineNotice);

app.config.globalProperties.$dayjs = dayjs;

// Determine which app to mount based on the renderMode
const mode = renderMode();
//console.log("RENDER MODE:", mode);

let mountedApp;

// Mount different apps based on the mode
switch (mode) {
  case RENDERING_MODES.SEARCH:
    mountedApp = createApp(SearchApp);
    break;
  case RENDERING_MODES.COMMERCIAL_ERRORREPORT:
    mountedApp = createApp(CommercialErrorreportApp);
    break;
  case RENDERING_MODES.ONCALL_ERRORREPORT:
    mountedApp = createApp(OncallErrorreportApp);
    break;
  case RENDERING_MODES.MY_PAGES:
    mountedApp = createApp(MyPagesApp);
    mountedApp.component('Navigation', Navigation);
    break;
  case RENDERING_MODES.CHANGE_EMAIL_BANKID:
    mountedApp = createApp(ChangeEmailApp);
    break;
  default:
    mountedApp = createApp(OfflineNotice); // Default app if no mode matches
    break;
}

//console.log("Mounted app:", mountedApp);

// Use the store and router for the selected app
mountedApp.use(store);
mountedApp.use(router);
mountedApp.use(dayjsPlugin);
mountedApp.use(veeValidatePlugin);

// Mount the app to the DOM
mountedApp.mount('#app');

})
